/* tslint:disable */
/* eslint-disable */
/**
 * POK
 * Opis api POK
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ChecklistItemDto } from './ChecklistItemDto';
import {
    ChecklistItemDtoFromJSON,
    ChecklistItemDtoFromJSONTyped,
    ChecklistItemDtoToJSON,
} from './ChecklistItemDto';

/**
 * 
 * @export
 * @interface GetChecklistDto
 */
export interface GetChecklistDto {
    /**
     * 
     * @type {string}
     * @memberof GetChecklistDto
     */
    projectId: string;
    /**
     * 
     * @type {string}
     * @memberof GetChecklistDto
     */
    stageDefinitionId: string;
    /**
     * 
     * @type {string}
     * @memberof GetChecklistDto
     */
    profileId?: string;
    /**
     * 
     * @type {Date}
     * @memberof GetChecklistDto
     */
    month?: Date;
    /**
     * 
     * @type {Array<ChecklistItemDto>}
     * @memberof GetChecklistDto
     */
    items: Array<ChecklistItemDto>;
    /**
     * Liczba wykonanych kroków
     * @type {number}
     * @memberof GetChecklistDto
     */
    completedCount: number;
    /**
     * Liczba wszystkich kroków
     * @type {number}
     * @memberof GetChecklistDto
     */
    totalCount: number;
}

/**
 * Check if a given object implements the GetChecklistDto interface.
 */
export function instanceOfGetChecklistDto(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "projectId" in value;
    isInstance = isInstance && "stageDefinitionId" in value;
    isInstance = isInstance && "items" in value;
    isInstance = isInstance && "completedCount" in value;
    isInstance = isInstance && "totalCount" in value;

    return isInstance;
}

export function GetChecklistDtoFromJSON(json: any): GetChecklistDto {
    return GetChecklistDtoFromJSONTyped(json, false);
}

export function GetChecklistDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetChecklistDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'projectId': json['projectId'],
        'stageDefinitionId': json['stageDefinitionId'],
        'profileId': !exists(json, 'profileId') ? undefined : json['profileId'],
        'month': !exists(json, 'month') ? undefined : (new Date(json['month'])),
        'items': ((json['items'] as Array<any>).map(ChecklistItemDtoFromJSON)),
        'completedCount': json['completedCount'],
        'totalCount': json['totalCount'],
    };
}

export function GetChecklistDtoToJSON(value?: GetChecklistDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'projectId': value.projectId,
        'stageDefinitionId': value.stageDefinitionId,
        'profileId': value.profileId,
        'month': value.month === undefined ? undefined : (value.month.toISOString()),
        'items': ((value.items as Array<any>).map(ChecklistItemDtoToJSON)),
        'completedCount': value.completedCount,
        'totalCount': value.totalCount,
    };
}

